import {
  Component,
  input,
  model,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { School } from '../../../types/school';
import { SchoolAuthorityDetail } from '../../../types/rest-api';
import { NavbarEntitySwitcherComponent } from './navbar-entity-switcher.component';

/**
 * Mobile top-left Schulgemeinde / Schuleinheit selector (primary blue bar — see Figma).
 * Logic and menu behavior live in {@link NavbarEntitySwitcherComponent}.
 */
@Component({
  selector: 'app-navbar-entity-switcher-primary',
  standalone: true,
  imports: [NavbarEntitySwitcherComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-navbar-entity-switcher
      variant="primary"
      [schools]="schools()"
      [authorities]="authorities()"
      [selectedEntityValue]="selectedEntityValue()"
      [dropdownOpen]="dropdownOpen()"
      (dropdownOpenChange)="dropdownOpen.set($event)"
      (entitySelected)="entitySelected.emit($event)" />
  `,
})
export class NavbarEntitySwitcherPrimaryComponent {
  schools = input.required<School[]>();
  authorities = input.required<SchoolAuthorityDetail[]>();
  selectedEntityValue = input.required<string>();
  dropdownOpen = model(false);
  entitySelected = output<string>();
}
